import { StipendRulesQuery } from "@common/utils/graphql";
import { ExtractTypename } from "@common/utils/graphql/utils";

export enum CreateStipendStep {
  CreateNewStipend = "create-new-stipend",
  SelectTemplate = "select-template",
  BaseForm = "base-form",
  DetailsForm = "details-form",
  RulePolicy = "rule-policy",
  Confirmation = "confirmation",
}

export type StipendRule = ExtractTypename<
  StipendRulesQuery["stipendRules"],
  "QueryStipendRulesSuccess"
>["data"]["stipendRules"]["0"];
